import React from 'react';
import { Button, Row, Spinner } from 'react-bootstrap';
import UserAllOrderItem from './UserAllOrderItem';
import UseAllOrders from '../../CustomHooks/User/UseAllOrders';
import Pagination from '../Layout/Pagination';
import { Link } from 'react-router-dom';

const UserAllOrdersContainer = () => {
  const [orderNumber, dataCards, paginate, onPress, handleChangeSearchInput, searchInputValue, loading] = UseAllOrders();

  return (
    <>
      {loading === false ? (
        <>
          {orderNumber > 0 ? (
            <p className="pb-4 fs-30 dark-color fw-bold"> You have {orderNumber + 1 || null} orders </p>
          ) : null}
          {orderNumber > 0 ? (
            <Row className='justify-content-between'>
              {dataCards ? (dataCards.map((item, index) => <UserAllOrderItem item={item} key={index} />)) : null}
            </Row>
          ) : (
            <div className='d-flex justify-content-center h-100 align-items-center flex-column'>
              <h5 className='fs-30 fw-bold dark-color mb-5'>You Don't have any orders</h5>
              <Link to="/">
                <Button className='orange-bg border-0 px-4 py-3 fs-30'>Go Shopping</Button>
              </Link>
            </div>
          )}

          {paginate && paginate.numberOfPages > 1 ? (
            <Pagination onPress={onPress} pageCount={paginate.numberOfPages} />
          ) : null}
        </>
      ) : (
        <div className='d-flex justify-content-center mt-5'>
          <Spinner variant='danger' animation="border" />
        </div>
      )}
    </>
  );
};

export default UserAllOrdersContainer;
